import APIService from '@/services/APIService.js';

export default {
  getUsuarioByUid(uid) {
    return APIService.apiCall().get(`/usuarios/get_usuario_by_uid/${uid}`);
  },
  getUsuariosOnlyUidAndPerfil() {
    return APIService.apiCall().get('/usuarios/get_usuarios_only_uid_and_perfil');
  },
  postUsuarioFromFirebase(admUid, postData, baseURL) {
    return APIService.apiCall().post(`/usuarios/salvar_usuario/${admUid}`, JSON.stringify(postData), {
      baseURL,
      timeout: 120000
    });
  },
  sendRequestEmail(nome, email) {
    const postData = { nome, email };
    return APIService.apiCall().post('/usuarios/send_request_email', JSON.stringify(postData));
  },
  sendRequestSlackHexaLite(postData) {
    return APIService.apiCall().post('/usuarios/sendRequestSlackHexaLite', JSON.stringify(postData));
  },
  sendPasswordByEmail(email, senha, modeloEmail = 'envia_senha_por_email_v2') {
    const postData = { email, senha, modeloEmail };
    return APIService.apiCall().post('/usuarios/envia_senha_por_email', JSON.stringify(postData));
  },
  manageStatusFirebaseAuth(postData) {
    return APIService.apiCall().post('/usuarios/manageFirebaseAuthStatus', JSON.stringify(postData));
  },
  cadastroUsuarioFirebase(postData) {
    return APIService.apiCall().post('/usuarios/cadastroUsuarioFirebase', JSON.stringify(postData));
  },
  alterarPerfilUsuario(postData, baseURL) {
    return APIService.apiCall().post('/usuarios/alterarPerfilUsuario', JSON.stringify(postData), { baseURL, timeout: 120000 });
  },
  resetUserPasswordByUid(uid) {
    const postData = { uid };
    return APIService.apiCall().post('/usuarios/redefinir_senha_admin', JSON.stringify(postData));
  }
};
